import styled from 'styled-components';

import { Sheet } from '@r1-frontend/ui-react/components/Modal';

import BaseBottomSheet from './BottomSheet';

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;

    overflow-y: hidden;

    transition: .5s;
    transform: translateY(0);

    width: 100%;
    max-height: calc(100vh - 80px);
    height: auto;

    box-sizing: border-box;
    z-index: 2;
`;

export const BottomSheet = styled(BaseBottomSheet)`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;

    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1000;
    visibility: visible;
    transition: opacity 0.5s, visibility 0.5s;

    &[aria-hidden="true"] {
        opacity: 0;
        visibility: hidden;
        pointer-events: none;

        ${Content} {
            transform: translateY(100%);
        }
    }

    ${Sheet} {
        padding: 18px 16px 16px 16px;
    }
`;
